import { ReportsList, ReportsShow } from 'pages/communication/reports';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'comments/resource_reports',
  label: 'Denúncias de comentários',
  list: ReportsList,
  show: ReportsShow,
  actions: ['list', 'show'],
  parentName: 'communication'
};

export default generateResources(resource);
